import { LicensingAgencyDocumentType } from '@/@types/generated'
import { DocumentPreviewDialog } from '@/components/Molecules/Files/DocumentPreviewDialog'
import { documentContentUrl } from '@/lib/documentContentUrl'
import { PropsWithChildren } from 'react'

interface LicensingAgencyDocumentPreviewProps {
  agencyId: string
  documentType: LicensingAgencyDocumentType
  title?: string
}

// Previews a licensing agency document in a dialog; `children` is the trigger.
export function LicensingAgencyDocumentPreview({
  agencyId,
  documentType,
  title = 'Preview Document',
  children,
}: PropsWithChildren<LicensingAgencyDocumentPreviewProps>) {
  const contentUrl = documentContentUrl.licensingAgency(agencyId, documentType)
  return (
    <DocumentPreviewDialog contentUrl={contentUrl} title={title}>
      {children}
    </DocumentPreviewDialog>
  )
}
